import { LEGACY } from 'styles/theme';

const IMG = '/images/bridal';

const page = {
  slug: 'the-bridal-cut',
  title: 'The Bridal Cut',
  hero: {
    title: 'The Bridal Cut',
    subtitle: 'Luxury NYC bridal wellness program that includes personalized nutrition guidance, individual personal training sessions and custom meal delivery designed to help you look and feel your best on your wedding day.',
    subtitleBelow: true,
    image: `${IMG}/hero.webp`,
  },
  blocks: [
    {
      type: 'split',
      image: `${IMG}/about.webp`,
      imageAlt: 'A bride in a white gown photographed on her wedding day',
      imageSide: 'right',
      groups: [
        {
          heading: 'About The Bridal Cut',
          paragraphs: [
            "The Bridal Cut is a results driven, luxury bridal wellness program designed to help you achieve your wedding day goals with confidence. Whether you're aiming to tone your arms, strengthen your back, define your abs or sculpt your entire body, your program is fully customized around your goals, timeline and current fitness level.",
            'We combine personalized fitness, expert nutrition advice, and chef-prepared meals into a results-driven program designed to help you look and feel your best for your wedding day.',
          ],
        },
      ],
    },
    {
      type: 'steps',
      heading: 'Our Integrated Approach',
      align: 'left',
      variant: 'portraits',
      tone: 'warm',
      items: [
        {
          image: `${IMG}/approach-training.webp`,
          imageAlt: 'Personal trainer Guy Codio in the gym',
          heading: 'Signature Personal Training',
          text: "Your program includes expert led private training with Guy Codio and the New York Personal Training team, fully-customized to your goals. Whether you're aiming for sculpted arms, a stronger back, improved posture, or full-body toning, every session is intentionally designed to help you look and feel your absolute best. We combine measurable progress tracking through data-driven metrics with ongoing accountability and expert guidance to help you achieve your ideal wedding-day physique.",
          cta: { label: 'Meet Guy Codio', href: 'https://newyorkpersonaltraining.com/guychard-codio/' },
        },
        {
          image: `${IMG}/approach-nutrition.webp`,
          imageAlt: 'Registered Dietitian Danielle Falchiere',
          heading: 'Personalized Nutrition Coaching',
          text: 'Work one-on-one with Registered Dietitian and Owner Danielle Falchiere and the One Nutrition Group team to create a nutrition plan tailored to your body, goals and lifestyle. This expert-led program includes private coaching, guidance on hormones, gut health, sleep and stress. We also provide ongoing support for travel, event planning, habits and accountability so your nutrition perfectly complements your fitness program.',
          cta: { label: 'Meet Danielle Falchiere', href: 'https://onenutritiongroup.com/about-us/danielle-falchiere/' },
        },
        {
          image: `${IMG}/approach-meals.webp`,
          imageAlt: 'Freshly prepared Square Fare meals in glass containers',
          heading: 'Custom Meals by Square Fare',
          text: 'Enjoy freshly-prepared meals designed specifically for your body and goals. Every meal is individually-tailored to your calorie and macronutrient needs, aligned with your nutrition plan, built around your preferences and dietary restrictions, and delivered fresh to your door. Losing weight and/or getting fit while eating well has never been this effortless or delicious.',
          cta: { label: "See This Week's Menu", href: `${LEGACY}/this-weeks-menu` },
        },
      ],
    },
    {
      type: 'gallery',
      variant: 'bleed',
      heading: 'Our Radiant Brides',
      items: [
        { image: `${IMG}/brides-1.webp`, imageAlt: 'A Bridal Cut bride on her wedding day' },
        { image: `${IMG}/brides-2.webp`, imageAlt: 'A Bridal Cut bride on her wedding day' },
        { image: `${IMG}/brides-3.webp`, imageAlt: 'A Bridal Cut bride on her wedding day' },
        { image: `${IMG}/brides-4.webp`, imageAlt: 'A Bridal Cut bride on her wedding day' },
        { image: `${IMG}/brides-5.webp`, imageAlt: 'A Bridal Cut bride on her wedding day' },
      ],
    },
    {
      type: 'cards',
      heading: 'Choose Your Package',
      align: 'left',
      items: [
        {
          title: 'One Year Bridal Cut Program',
          price: 'from $1,755.00 every month for 1 year',
          lines: [
            '2 private personal training sessions per week',
            '16 nutrition coaching appointments per year',
            'Fully-tailored meals delivered to your door',
            'Comprehensive body composition analysis to track muscle and fat percentages',
            'Personalized calorie and macronutrient plan',
            'Ongoing mindset, habit and accountability support',
            '# Meals / Week: 5 / 6 / 7 / 8 / 9 / 10',
          ],
          image: `${IMG}/card-1year.webp`,
          imageAlt: 'Bride photographed during the One Year Bridal Cut Program',
          cta: {
            label: 'Get Started Now',
            href: 'https://www.getsquarefare.com/this-weeks-meals/p/tailored-meals-a4hy3-s4fng-dee9f-px65n-8nes4-dd9gr-gr8cw-7m7xy-apmgx-8znkt-mjtsh-glfbh-6b696-h96p7-2syxx-k7fn8-k9kak-6wyjf-lp6ke-rxeh9-6hy34-txxrj-cjzwl-nw4mj-gxcfg-p22rf-kj3lf-84gzh',
          },
        },
        {
          title: '6 Month Bridal Cut Program',
          price: '$2,224.00 every month for 6 months',
          lines: [
            '2 private personal training sessions per week (52 sessions over six months)',
            '10 nutrition coaching appointments over 6 months',
            '10 fully-tailored meals delivered to your door weekly',
            'Comprehensive body composition analysis to track muscle and fat percentages',
            'Personalized calorie and macronutrient plan',
            'Ongoing mindset, habit and accountability support',
          ],
          image: `${IMG}/card-6month.webp`,
          imageAlt: 'Bride photographed during the 6 Month Bridal Cut Program',
          cta: {
            label: 'Get Started Now',
            href: 'https://www.getsquarefare.com/this-weeks-meals/p/tailored-meals-a4hy3-s4fng-dee9f-px65n-8nes4-dd9gr-gr8cw-7m7xy-apmgx-8znkt-mjtsh-glfbh-6b696-h96p7-2syxx-k7fn8-k9kak-6wyjf-lp6ke-rxeh9-6hy34-txxrj-cjzwl-nw4mj-gxcfg-p22rf-kj3lf-84gzh-lp6dz-8fwrb',
          },
        },
        {
          title: '3 Month Bridal Cut Program',
          price: '$3,662.00 every month for 3 months',
          lines: [
            '3 private personal training sessions per week (36 sessions over 3 months)',
            '2 nutrition coaching appointments per month (6 appointments over 3 months)',
            'Custom 7-Day Meal Plan delivered to your door (21 meals per week plus snacks)',
            'Comprehensive body composition analysis to track muscle and fat percentages',
            'Personalized calorie and macronutrient plan',
            'Ongoing mindset, habit and accountability support',
          ],
          image: `${IMG}/card-3month.webp`,
          imageAlt: 'Bride photographed during the 3 Month Bridal Cut Program',
          cta: {
            label: 'Get Started Now',
            href: 'https://www.getsquarefare.com/this-weeks-meals/p/tailored-meals-a4hy3-s4fng-dee9f-px65n-8nes4-dd9gr-gr8cw-7m7xy-apmgx-8znkt-mjtsh-glfbh-6b696-h96p7-2syxx-k7fn8-k9kak-6wyjf-lp6ke-rxeh9-6hy34-txxrj-cjzwl-nw4mj-gxcfg-p22rf-kj3lf-84gzh-lp6dz',
          },
        },
      ],
    },
    {
      type: 'gallery',
      variant: 'bleed',
      items: [
        { image: `${IMG}/gallery-1.webp`, imageAlt: 'A Bridal Cut bride on her wedding day' },
        { image: `${IMG}/gallery-2.webp`, imageAlt: 'A Bridal Cut bride on her wedding day' },
        { image: `${IMG}/gallery-3.webp`, imageAlt: 'A Bridal Cut bride on her wedding day' },
        { image: `${IMG}/gallery-4.webp`, imageAlt: 'A Bridal Cut bride on her wedding day' },
        { image: `${IMG}/gallery-5.webp`, imageAlt: 'A Bridal Cut bride on her wedding day' },
      ],
    },
    {
      type: 'formBand',
      heading: 'Apply Today',
      tone: 'warm',
      paragraphs: [
        "Because this is a highly personalized experience, we take on a limited number of brides. Once we have a better understanding of your timeline and what you're envisioning, we'll reach out with availability and next steps.",
        "Please fill out the form beside, and a member of our team will be in touch soon. We're so excited to be part of your journey.",
      ],
      form: {
        formType: 'bridal',
        submitLabel: 'Submit',
        // The dates, insurance question and package picker are unique to this
        // application, so they carry their own definitions.
        fields: [
          'firstName',
          { key: 'lastName', required: false },
          'email',
          'newsletter',
          { key: 'phone', label: 'Phone', required: true },
          { key: 'weddingDate', label: 'When is your wedding date?', type: 'date', required: true },
          { key: 'startDate', label: 'When do you want to start?', type: 'date', required: true },
          {
            key: 'insurance',
            label: 'Do you have insurance?',
            select: true,
            options: ['Yes', 'No', 'Not sure'],
          },
          {
            key: 'program',
            label: 'Which program are you interested in?',
            select: true,
            required: true,
            options: [
              'One Year Bridal Cut Program',
              '6 Month Bridal Cut Program',
              '3 Month Bridal Cut Program',
              'Not sure yet',
            ],
          },
        ],
      },
    },
    {
      type: 'columns',
      items: [
        {
          heading: 'Get in Touch',
          bold: true,
          size: 'lg',
          paragraphs: [
            'Reach out anytime with questions:',
            [
              'Guy Codio | ',
              { label: '(646) 942-9827', href: 'tel:+16469429827' },
              ' | ',
              { label: 'thebridalcut@getsquarefare.com', href: 'mailto:thebridalcut@getsquarefare.com' },
            ],
          ],
        },
      ],
    },
    {
      type: 'ctaGroup',
      heading: 'Still Have Questions?',
      actions: [
        { label: 'Contact Us', to: '/contact-form-general' },
        { label: 'Visit FAQ', to: '/faqs'},
      ],
    },
  ],
};

export default page;
